import { useEffect, useRef, useState } from 'react'
import renderImage from '../../../../source/importImg'
import styles from './ActionCreateNew.module.css'
import createStyle from '../ActionsCreate.module.css'

import WaveSurfer from 'wavesurfer.js'
import RegionsPlugin from 'wavesurfer.js/dist/plugins/regions.js'
import TimelinePlugin from 'wavesurfer.js/dist/plugins/timeline.js'
import ZoomPlugin from 'wavesurfer.js/dist/plugins/zoom.js'
import { SINGLEACTIONSTATE } from '../defaultData'
import ActionCreateTableRow from './ActionCreateTableRow'
import { useIndexedDB } from 'react-indexed-db'
import { trimMp3DataUrlRange } from '../../../../utils/mp3Trim'

const TRIM_REGION_ID = 'trim-region'

const trimIcon = (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="currentColor"
        viewBox="0 0 16 16"
        width="100%"
        height="100%"
    >
        <path d="M3.5 3.5c-.614-.884-.074-1.962.858-2.5L8 7.226 11.642 1c.932.538 1.472 1.616.858 2.5L8.81 8.61l1.556 2.661a2.5 2.5 0 1 1-.794.637L8 9.73l-1.572 2.177a2.5 2.5 0 1 1-.794-.637L7.19 8.61 3.5 3.5zm2.5 10a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0zm7 0a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0z" />
    </svg>
)

const trimConfirmIcon = (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="currentColor"
        viewBox="0 0 16 16"
        width="100%"
        height="100%"
    >
        <path d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425a.247.247 0 0 1 .02-.022z" />
    </svg>
)

const trimCancelIcon = (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="currentColor"
        viewBox="0 0 16 16"
        width="100%"
        height="100%"
    >
        <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z" />
    </svg>
)

const TrimControlButton = ({ icon, color, tooltip, onClick, isActive }) => (
    <div
        className={styles.audioControlBtnDiv}
        style={{
            marginLeft: '1vw',
        }}
    >
        <span
            className={`${styles.btnStyle} ${styles.playPauseBtn} ${createStyle.audioDeleteBtn}`}
            onClick={onClick}
            style={{
                aspectRatio: '1 / 1',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                padding: '0.55vw',
                boxSizing: 'border-box',
                borderRadius: '50%',
                backgroundColor: '#ffffff',
                border: `2px solid ${color}`,
                boxShadow: '0 2px 4px rgba(0, 0, 0, 0.15)',
                color: color,
                cursor: isActive ? 'pointer' : 'default',
            }}
        >
            {icon}
        </span>
        <p
            className={`${createStyle.tooltip} ${createStyle.audioDeleteBtnTooltip}`}
            style={{
                position: 'absolute',
                left: '50%',
                top: '-50%',
                transform: 'translate(-50%, -50%)',
            }}
        >
            {tooltip}
        </p>
    </div>
)

const timeline = TimelinePlugin.create({})
// const regions = RegionsPlugin.create({})
const zoomPlugin = ZoomPlugin.create({
    // the amount of zoom per wheel step, e.g. 0.5 means a 50% magnification per scroll
    scale: 0.5,
    // Optionally, specify the maximum pixels-per-second factor while zooming
    maxZoom: 100,
})

function ActionCreateNew({
    regions,
    allActions,
    addNewAction,
    deleteAction,
    handleSelectAction,
    selectedAction,
    updateMarkerById,
    handlePlayAction,
    servoDetailsPopupOpen,
    // isAudioEnable,
    tableBodyRef,
    waveSurferRef,
    display,
    setDisplay,
    setShowDeviceModal,
    actionNameChange,
    audioFile,
    setAudioFile,
    createActionState,
    setCreateActionState,
    sendReadServoBytes,
    portalPopupRef,
    isMotorTorqueEnable,
    setShowDeviceConnectModal,
}) {
    const connectedDevice =
        sessionStorage.getItem('connectedDevice') || 'Humanoid'
    const deviceVersion = sessionStorage.getItem('deviceVersion') || '1.0.1'

    const waveformDivRef = useRef(null)
    const { add, clear } = useIndexedDB('AudioFiles')
    // const waveSurferRef = useRef(null)

    // const [audioFile, setAudioFile] = useState(null)
    const [playAudio, setPlayAudio] = useState(false)
    // const [markers, setMarkers] = useState([])
    const fileInputRef = useRef(null)
    const [isDragging, setIsDragging] = useState(false)
    const [isTrimming, setIsTrimming] = useState(false)
    const isTrimmingRef = useRef(false)
    const trimRegionRef = useRef(null)

    //click on the uload button
    const handelFileUploadBtn = () => {
        // if (!isAudioEnable) {
        //     return
        // }
        // console.log('HHHHHH')
        if (fileInputRef?.current) {
            fileInputRef.current.click()
        }
    }

    //handel the file read
    const fileRead = (file, fileInput) => {
        try {
            //check it is a mp3 file or not
            if (!file.name.toLowerCase().endsWith('.mp3')) {
                return
            }
            sessionStorage.setItem('isSave', JSON.stringify(false))
            setPlayAudio(false)

            const reader = new FileReader()
            reader.readAsDataURL(file)

            reader.onload = async () => {
                try {
                    const fileData = reader.result
                    setAudioFile(fileData)

                    const id = await add({
                        fileName: file.name,
                        fileData: fileData,
                    })

                    console.log('Audio file added with ID:', id)
                } catch (error) {
                    console.error(error)
                } finally {
                    console.log('File processing completed')
                    if (fileInput) fileInput.value = '' // Reset input after processing
                }
            }
        } catch (e) {
            console.error(e)
        }
    }

    //handel upload audio file
    const handelFileUpload = async (e) => {
        const fileInput = e.target // Store file input reference
        const file = fileInput.files[0]

        if (!file) return // Prevent errors if no file is selected
        fileRead(file, fileInput)
    }

    //drop the mp3 file in the ui box
    const handleDrop = (event) => {
        event.preventDefault()
        setIsDragging(false)

        const file = event.dataTransfer.files[0]
        fileRead(file)
    }

    const handleDragOver = (event) => {
        event.preventDefault()
        setIsDragging(true)
    }

    const handleDragLeave = () => {
        setIsDragging(false)
    }

    //handel click the pay pause button of the audio
    //the play/pause icon state follows the wavesurfer play and pause events,
    //so it stays in sync even when playback is started from the action group
    const handelPlayPause = () => {
        if (waveSurferRef?.current && display !== 'none' && audioFile) {
            waveSurferRef.current.playPause()
        }
    }

    // audioPlayRef.current = function palyAudio() {
    //     if (waveSurferRef?.current) {
    //         waveSurferRef.current.playPause()
    //         // setPlayAudio(!playAudio)
    //     }
    // }

    //handel click the restart button  of the audio
    const handelRestart = () => {
        if (waveSurferRef?.current) {
            waveSurferRef.current.setTime(0)
        }
    }

    // Handles clicking the forward or backward button of the audio player.
    // Moves the audio playback forward or backward by the specified skipTime in seconds.
    const handelForWardBackWard = (skipTime) => {
        if (waveSurferRef?.current) {
            waveSurferRef.current.skip(skipTime)
        }
    }

    //force the waveform canvas to span the full container width at base zoom
    const refitWaveform = () => {
        const ws = waveSurferRef.current
        const container = waveformDivRef.current
        if (!ws || !container) return
        const duration = ws.getDuration()
        if (!duration) return
        const minPxPerSec = ws.options.minPxPerSec || 0
        if (minPxPerSec === 0) return
        const containerWidth = container.clientWidth
        //preserve the user's zoom-in; only snap back to full width at base zoom
        if (minPxPerSec * duration <= containerWidth + 2) {
            ws.zoom(0)
        }
    }

    // Initialize WaveSurfer
    useEffect(() => {
        setPlayAudio(false)
        setIsTrimming(false)
        isTrimmingRef.current = false
        trimRegionRef.current = null
        if (waveformDivRef.current && audioFile) {
            const timelineHeight = 20
            const scrollbarHeight = 16
            const waveformHeight = Math.max(
                waveformDivRef.current.offsetHeight -
                    timelineHeight -
                    scrollbarHeight,
                60
            )
            waveSurferRef.current = WaveSurfer.create({
                container: waveformDivRef.current,
                waveColor: '#59b6d6',
                // progressColor: '#03a1d6',
                progressColor: '#00C462',
                backend: 'MediaElement',
                // height: '100',
                height: waveformHeight,
                url: audioFile,
                // mediaControls: true,
                // height: '50',
                // url: URL.createObjectURL(audioFile),
                // interact: false,
                plugins: [timeline, regions, zoomPlugin],
            })

            // waveSurferRef.current.load(URL.createObjectURL(audioFile))

            // Handle click to add markers
            waveSurferRef.current.on('click', (e) => {
                if (isTrimmingRef.current) return
                const time = waveSurferRef.current.getCurrentTime()

                // const { prevTimeInterval, nextTimeInterVal } =
                //     timeInterValCalculate(time.toFixed(3))
                // console.log(
                //     'JJJJJJJ11111222222',
                //     prevTimeInterval,
                //     nextTimeInterVal
                // )
                // if (
                //     prevTimeInterval < 0.1 ||
                //     prevTimeInterval > 5 ||
                //     nextTimeInterVal < 0.1 ||
                //     nextTimeInterVal > 5
                // ) {
                //     return
                // }
                let region1 = regions.addRegion({
                    start: time,
                    content: `${time.toFixed(3)}`,
                    color: 'rgba(255, 0, 0, 0.5)',
                })

                // sortMarker({ time: region1.start.toFixed(3), id: region1.id })
                addNewAction({
                    markerPositionTime: region1.start.toFixed(3),
                    id: region1.id,
                })
            })

            //handel the drag the marker update the time
            regions.on('region-updated', (region1, t) => {
                if (region1.id === TRIM_REGION_ID) return
                console.log('region-updated', region1, t)

                //handel the drag to prevent the marker put at end of the audio.
                const duration = (
                    waveSurferRef.current.getDuration() - 0.05
                ).toFixed(3)
                if (duration < region1.start) {
                    region1.setOptions({
                        end: duration,
                        start: duration,
                    })
                }
                region1.setOptions({
                    content: `${region1.start.toFixed(3)}`,
                })

                updateMarkerById(region1.id, region1.start.toFixed(3))
            })

            // waveSurferRef.current.on('decode', () => {
            //     markers.map((mark) => {
            //         regions.addRegion({
            //             start: mark.time,
            //             content: `${mark.time}`,
            //             color: 'rgba(255, 0, 0, 0.5)',
            //         })
            //     })
            // })

            /** When the audio is both decoded and can play */
            waveSurferRef.current.on('ready', (duration) => {
                refitWaveform()

                setCreateActionState((prev) => {
                    let newAllActions = prev.allActions.map((action) => {
                        let region1 = regions.addRegion({
                            start: action.markerPositionTime,
                            content: `${action.markerPositionTime}`,
                            color: 'rgba(255, 0, 0, 0.5)',
                        })

                        action.id = region1.id
                        return action
                    })

                    return { ...prev, allActions: newAllActions }
                })
            })

            waveSurferRef.current.on('redrawcomplete', () => {
                refitWaveform()
            })

            waveSurferRef.current.on('play', () => {
                setPlayAudio(true)
            })

            waveSurferRef.current.on('pause', () => {
                setPlayAudio(false)
            })

            //when finish the audio play change the play mode
            waveSurferRef.current.on('finish', () => {
                setPlayAudio(false)
            })

            //keep the waveform filling the full container width on resize
            let resizeObserver
            if (typeof ResizeObserver === 'function') {
                resizeObserver = new ResizeObserver(() => {
                    refitWaveform()
                })
                resizeObserver.observe(waveformDivRef.current)
            }

            // Cleanup
            return () => {
                if (resizeObserver) {
                    resizeObserver.disconnect()
                }
                waveSurferRef.current.destroy()
            }
        }
        if (!audioFile) {
            waveSurferRef.current = null
        }
    }, [audioFile])

    //delete the marker and corresponding action
    const deleteMarker = (event, actionNumber, id) => {
        // if (isAudioEnable) {
        const regionss = regions.getRegions()
        const deletedRegion = regionss.find((ele) => {
            if (ele.id === id) {
                return ele
            }
        })
        if (deletedRegion) {
            deletedRegion.remove()
            deleteAction(event, actionNumber)
        } else {
            console.warn(`Region with id ${id} not found.`)
            deleteAction(event, actionNumber)
        }
        // } else {
        //     deleteAction(event, actionNumber)
        // }
    }

    //delete the audio file from ui
    const handelDeleteAudio = async () => {
        await clear()
        setAudioFile(null)
        setPlayAudio(false)
    }

    //restart the audio file
    const handelRestartAudio = () => {
        if (waveSurferRef?.current) {
            waveSurferRef.current.setTime(0)
        }
    }

    //start the trim mode by adding a resizable selection region over the waveform
    const handelTrimStart = () => {
        if (
            !waveSurferRef?.current ||
            !audioFile ||
            isTrimming ||
            display === 'none'
        ) {
            return
        }
        const duration = waveSurferRef.current.getDuration()
        if (!duration) return
        trimRegionRef.current = regions.addRegion({
            id: TRIM_REGION_ID,
            start: 0,
            end: duration,
            color: 'rgba(3, 161, 214, 0.2)',
            drag: true,
            resize: true,
        })
        isTrimmingRef.current = true
        setIsTrimming(true)
    }

    //exit the trim mode without applying the selection
    const handelTrimCancel = () => {
        if (trimRegionRef.current) {
            trimRegionRef.current.remove()
        }
        trimRegionRef.current = null
        isTrimmingRef.current = false
        setIsTrimming(false)
    }

    //keep only the selected part of the audio, drop or shift the action markers
    //to match the new timeline and replace the stored audio file
    const handelTrimConfirm = async () => {
        try {
            const trimRegion = trimRegionRef.current
            if (!waveSurferRef?.current || !trimRegion || !audioFile) return
            const duration = waveSurferRef.current.getDuration()
            const start = Math.max(0, trimRegion.start)
            const end = Math.min(duration, trimRegion.end)
            if (end - start < 1) {
                setShowDeviceConnectModal({
                    isShow: true,
                    text: 'The trimmed audio must be at least 1 second long.',
                })
                return
            }
            if (waveSurferRef.current.isPlaying()) {
                waveSurferRef.current.pause()
            }

            const trimmedDataURL = trimMp3DataUrlRange(audioFile, start, end)
            if (!trimmedDataURL) {
                handelTrimCancel()
                setShowDeviceConnectModal({
                    isShow: true,
                    text: 'Unable to trim this audio file. Please try again.',
                })
                return
            }

            const newCreateActionState = JSON.parse(
                JSON.stringify(createActionState)
            )
            const keptActions = newCreateActionState.allActions.filter(
                (action) => {
                    const markerTime = Number(action.markerPositionTime)
                    return markerTime >= start && markerTime <= end
                }
            )
            let previousTime = 0
            keptActions.forEach((action) => {
                const newMarkerTime = Number(action.markerPositionTime) - start
                action.markerPositionTime = newMarkerTime.toFixed(3)
                action.data.T.value = Math.round(
                    (newMarkerTime - previousTime) * 1000
                )
                previousTime = newMarkerTime
            })
            newCreateActionState.allActions = keptActions

            sessionStorage.setItem('isSave', JSON.stringify(false))
            setCreateActionState(newCreateActionState)

            await clear()
            await add({
                fileName: 'trimmedAudio.mp3',
                fileData: trimmedDataURL,
            })
            setAudioFile(trimmedDataURL)
        } catch (e) {
            console.error(e)
            handelTrimCancel()
            setShowDeviceConnectModal({
                isShow: true,
                text: 'Unable to trim this audio file. Please try again.',
            })
        }
    }

    //copy the same action details
const handelCopyAction = async (actionNumber, id) => {
    try {
        let newCreateActionState = JSON.parse(
            JSON.stringify(createActionState)
        )
        let newAction = JSON.parse(
            JSON.stringify(newCreateActionState.allActions[actionNumber])
        )

        newCreateActionState.allActions.splice(actionNumber + 1, 0, newAction)


        let cumulativeTime = 0
        newCreateActionState.allActions = newCreateActionState.allActions.map(
            (action) => {
                cumulativeTime += action.data['T'].value
                return {
                    ...action,
                    markerPositionTime: (cumulativeTime / 1000).toFixed(3),
                }
            }
        )

        const insertedAction = newCreateActionState.allActions[actionNumber + 1]

        if (waveSurferRef.current) {
            let region1 = regions.addRegion({
                start: Number(insertedAction.markerPositionTime),
                content: `${insertedAction.markerPositionTime}`,
                color: 'rgba(255, 0, 0, 0.5)',
            })
            insertedAction.id = region1.id


            const allRegions = regions.getRegions()
            newCreateActionState.allActions.forEach((action) => {
                if (action.id === insertedAction.id) return
                const region = allRegions.find((ele) => ele.id === action.id)
                if (region) {
                    region.setOptions({
                        start: Number(action.markerPositionTime),
                        content: `${action.markerPositionTime}`,
                    })
                }
            })
        } else {
            insertedAction.id = Math.random().toString(16).slice(2, 6)
        }

        setCreateActionState(newCreateActionState)
    } catch (e) {
        console.log(e)
    }
}

    return (
        <div className={styles.mainDiv}>
            <div className={styles.mainUpper}>
                {/* ------------------------- Wave from of the audio --------------------------------------------- */}
                {/* {!isAudioEnable && (
                    <div className={styles.waveFromDiv}>
                        <div className={styles.audioDisable}></div>
                    </div>
                )} */}
                {/* {isAudioEnable && ( */}
                <div className={styles.waveFromDivParent}>
                    <div className={styles.waveFromDiv}>
                        {audioFile ? (
                            <div
                                style={{ height: '14vh' }}
                                className={styles.waveFromRefDiv}
                                ref={waveformDivRef}
                            ></div>
                        ) : (
                            <div
                                className={styles.waveFromEmptyDiv}
                                onDrop={handleDrop}
                                onDragOver={handleDragOver}
                                onDragLeave={handleDragLeave}
                                style={{
                                    borderColor: isDragging
                                        ? '#03a1d6'
                                        : 'gray',
                                }}
                            >
                                <p>Drag & Drop an MP3 file here</p>
                            </div>
                        )}
                    </div>

                    <div style={{ display: 'flex' }}>
                        <div
                            className={styles.audioControlBtnDiv}
                            style={{
                                marginLeft: '2vw',
                            }}
                        >
                            <img
                                onClick={handelFileUploadBtn}
                                className={`${styles.btnStyle} ${styles.uploadBtn} ${createStyle.uploadBtn1}`}
                                src={renderImage('uploadBtn')}
                                alt="upload Button"
                                width="60vw"
                            />
                            <p
                                className={`${createStyle.tooltip} ${createStyle.uploadBtnTooltip}`}
                                style={{
                                    position: 'absolute',
                                    left: '50%',
                                    top: '-50%',
                                    transform: 'translate(-50%, -50%)',
                                }}
                            >
                                Upload
                            </p>
                            <input
                                style={{ display: 'none' }}
                                type="file"
                                accept="audio/mp3"
                                ref={fileInputRef}
                                onChange={handelFileUpload}
                            />
                        </div>

                        <div
                            className={styles.audioControlBtnDiv}
                            style={{
                                marginLeft: '1vw',
                            }}
                        >
                            <img
                                style={audioFile ? {} : { cursor: 'default' }}
                                onClick={handelPlayPause}
                                className={`${styles.btnStyle} ${styles.playPauseBtn} ${createStyle.audioPlayBtn}`}
                                src={renderImage(
                                    playAudio ? 'pauseBtn' : 'playBtn'
                                )}
                                alt="Play Button"
                                width="30vw"
                            />
                            <p
                                className={`${createStyle.tooltip} ${createStyle.audioPlayBtnTooltip}`}
                                style={{
                                    position: 'absolute',
                                    left: '50%',
                                    top: '-50%',
                                    transform: 'translate(-50%, -50%)',
                                }}
                            >
                                Play/Pause
                            </p>
                        </div>

                        <div
                            className={styles.audioControlBtnDiv}
                            style={{
                                marginLeft: '1vw',
                            }}
                        >
                            <img
                                // width="25vw"
                                className={`${styles.btnStyle} ${styles.playPauseBtn} ${createStyle.audioDeleteBtn}`}
                                src={renderImage('deleteBtn')}
                                alt="delete button"
                                onClick={(event) => {
                                    handelDeleteAudio()
                                }}
                                style={audioFile ? {} : { cursor: 'default' }}
                            />
                            <p
                                className={`${createStyle.tooltip} ${createStyle.audioDeleteBtnTooltip}`}
                                style={{
                                    position: 'absolute',
                                    left: '50%',
                                    top: '-50%',
                                    transform: 'translate(-50%, -50%)',
                                }}
                            >
                                Delete
                            </p>
                        </div>

                        <div
                            className={styles.audioControlBtnDiv}
                            style={{
                                marginLeft: '1vw',
                            }}
                        >
                            <img
                                // width="25vw"
                                className={`${styles.btnStyle} ${styles.playPauseBtn} ${createStyle.audioDeleteBtn}`}
                                src={renderImage('restartBtn')}
                                alt="restart button"
                                onClick={(event) => {
                                    handelRestartAudio()
                                }}
                                style={audioFile ? {} : { cursor: 'default' }}
                            />
                            <p
                                className={`${createStyle.tooltip} ${createStyle.audioDeleteBtnTooltip}`}
                                style={{
                                    position: 'absolute',
                                    left: '50%',
                                    top: '-50%',
                                    transform: 'translate(-50%, -50%)',
                                }}
                            >
                                Restart
                            </p>
                        </div>

                        {!isTrimming ? (
                            <TrimControlButton
                                icon={trimIcon}
                                color="#262262"
                                tooltip="Trim"
                                onClick={handelTrimStart}
                                isActive={!!audioFile}
                            />
                        ) : (
                            <>
                                <TrimControlButton
                                    icon={trimConfirmIcon}
                                    color="#00C462"
                                    tooltip="Apply Trim"
                                    onClick={handelTrimConfirm}
                                    isActive={true}
                                />
                                <TrimControlButton
                                    icon={trimCancelIcon}
                                    color="#ff4b4b"
                                    tooltip="Cancel Trim"
                                    onClick={handelTrimCancel}
                                    isActive={true}
                                />
                            </>
                        )}
                    </div>
                </div>
                {/* )} */}

                {/* ------------------ Control Panel Button -------------------- -------------------*/}
                {/* <div className={styles.controlDiv}>
                    <div className={styles.controlBtnDiv}>
                        <img
                            onClick={handelFileUploadBtn}
                            className={`${styles.btnStyle} ${
                                isAudioEnable ? '' : styles.disableBtnStyle
                            }`}
                            src={renderImage('uploadBtn')}
                            alt="upload Button"
                            width="30vw"
                        />
                        <input
                            style={{ display: 'none' }}
                            type="file"
                            accept="audio/mp3"
                            ref={fileInputRef}
                            onChange={handelFileUpload}
                        />
                    </div>
                    <div className={styles.controlBtnDiv}>
                        <img
                            onClick={handelPlayPause}
                            className={`${styles.btnStyle} ${
                                isAudioEnable ? '' : styles.disableBtnStyle
                            }`}
                            src={renderImage(
                                playAudio ? 'pauseBtn' : 'playBtn'
                            )}
                            alt="Play Button"
                            width="30vw"
                        />
                        <img
                            onClick={handelRestart}
                            className={`${styles.btnStyle} ${
                                isAudioEnable ? '' : styles.disableBtnStyle
                            }`}
                            src={renderImage('restartBtn')}
                            alt="Restart Button"
                            width="30vw"
                        />
                    </div>
                    <div className={styles.controlBtnDiv}>
                        <img
                            onClick={() => handelForWardBackWard(10)}
                            className={`${styles.btnStyle} ${
                                isAudioEnable ? '' : styles.disableBtnStyle
                            }`}
                            src={renderImage('forwardBtn')}
                            alt="Forward Button"
                            width="30vw"
                        />
                        <img
                            style={{ transform: 'rotate(180deg)' }}
                            onClick={() => handelForWardBackWard(-10)}
                            className={`${styles.btnStyle} ${
                                isAudioEnable ? '' : styles.disableBtnStyle
                            }`}
                            src={renderImage('forwardBtn')}
                            alt="Backrward Button"
                            width="30vw"
                        />
                    </div>
                </div> */}

                {/* ---------------------------- Device Image -------------------------------------------- */}
                <div className={styles.deviceImageDivParent}>
                    <div className={styles.deviceImageDiv}>
                        <img
                            onClick={setShowDeviceModal}
                            src={renderImage(
                                connectedDevice === 'Humanoid'
                                    ? 'humanoid'
                                    : 'hexapod'
                            )}
                            height="80%"
                            width="85%"
                        />
                        <p className={styles.imageText}>View Motors</p>
                    </div>
                </div>
            </div>

            {/* ----------------- table part of the ui ------------------------------------------ */}
            <div className={styles.mainLower}>
                {/* ----------------- table header of the ui ------------------------------------------ */}
                {/* <div className={styles.tableHeader}>
                    <div className={styles.tableHeaderLeft}>
                        {isAudioEnable && (
                            <p className={styles.tableHeaderMarks}>Marks</p>
                        )}
                        <p className={styles.tableHeaderActions}>Actions</p>
                    </div>
                    <div className={styles.tableHeaderRight}>
                        <p className={styles.tableHeaderMotor}>Motors</p>
                    </div>
                </div> */}

                {/* -----------------  table Body of the ui ------------------------------------------ */}
                <div ref={tableBodyRef} className={styles.tableBody}>
                    {allActions &&
                        allActions.map((element, ind) => {
                            return (
                                <div key={element.id}>
                                    <ActionCreateTableRow
                                        action={element}
                                        actionNumber={ind}
                                        handleSelectAction={handleSelectAction}
                                        selectedAction={selectedAction}
                                        deleteMarker={deleteMarker}
                                        handlePlayAction={handlePlayAction}
                                        servoDetailsPopupOpen={
                                            servoDetailsPopupOpen
                                        }
                                        // isAudioEnable={isAudioEnable}
                                        actionNameChange={actionNameChange}
                                        display={display}
                                        setDisplay={setDisplay}
                                        sendReadServoBytes={sendReadServoBytes}
                                        portalPopupRef={portalPopupRef}
                                        handelCopyAction={handelCopyAction}
                                        isMotorTorqueEnable={
                                            isMotorTorqueEnable
                                        }
                                        setShowDeviceConnectModal={
                                            setShowDeviceConnectModal
                                        }
                                    />
                                </div>
                            )
                        })}
                </div>
            </div>
        </div>
    )
}

export default ActionCreateNew